//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents how a Page should be displayed in the page navigation controls. */
export const DisplayInNavWhen = {
    /** Display this page in navigation controls when allowed by security */
    WhenAllowed: 0,

    /** Always display this page in navigation controls, regardless of security */
    Always: 1,

    /** Never display this page in navigation controls */
    Never: 2
} as const;

/** Represents how a Page should be displayed in the page navigation controls. */
export const DisplayInNavWhenDescription: Record<number, string> = {
    0: "When Allowed",

    1: "Always",

    2: "Never"
};

/** Represents how a Page should be displayed in the page navigation controls. */
export type DisplayInNavWhen = typeof DisplayInNavWhen[keyof typeof DisplayInNavWhen];
